<template>
  <v-expansion-panels>
    <v-expansion-panel>
      <v-expansion-panel-header
        class="px-3"
        color="var(--kaki)"
      >
        <div class="d-flex justify-start align-center">
          <v-icon
            class="pr-3"
            color="secondary"
          >
            mdi-information-outline
          </v-icon>
          <span class="action secondary--text">
            Comment est calculé le prix payé ?
          </span>
        </div>
      </v-expansion-panel-header>
      <v-expansion-panel-content color="var(--kaki)">
        <div class="d-flex flex-column">
          <span class="texte texte-gris-fonce">
            Nous avons pris en compte l’ensemble de ces critères :
          </span>
          <div class="d-flex pt-2 justify-space-between">
            <span class="intro texte-gris-fonce py-3">
              Prix de base {{ isPrixProvisoire ? 'prov.' : '' }}
            </span>
            <span class="titre-h4 py-2 align-end secondary--text">
              {{ constructionPrix.prixBaseEnEuroParTonne | roundNumber(2) }} €/t
            </span>
          </div>
          <v-divider />
          <div
            v-if="constructionPrix.fraisAssurancesCallEnEuroParTonne"
            class="d-flex pt-2 justify-space-between"
          >
            <span class="intro texte-gris-fonce py-3">
              Frais option
            </span>
            <span class="titre-h4 py-2 align-end secondary--text">
              {{ formatValeurAddition(constructionPrix.fraisAssurancesCallEnEuroParTonne, 2, '€/t') }}
            </span>
          </div>
          <v-divider v-if="constructionPrix.fraisAssurancesCallEnEuroParTonne" />
          <div
            v-if="constructionPrix.primeLogistiqueEnEuroParTonne"
            class="d-flex pt-2 justify-space-between"
          >
            <span class="intro texte-gris-fonce py-3">
              Prime logistique
            </span>
            <span class="titre-h4 py-2 align-end secondary--text">
              {{ formatValeurAddition(constructionPrix.primeLogistiqueEnEuroParTonne, 2, '€/t') }}
            </span>
          </div>
          <v-divider v-if="constructionPrix.primeLogistiqueEnEuroParTonne" />
          <div
            v-if="constructionPrix.bonificationQualiteTotaleEnEuroParTonne"
            class="d-flex pt-2 justify-space-between"
          >
            <span class="intro texte-gris-fonce py-3">
              Total des qualités
            </span>
            <span class="titre-h4 py-2 align-end secondary--text">
              {{ formatValeurAddition(constructionPrix.bonificationQualiteTotaleEnEuroParTonne, 2, '€/t') }}
            </span>
          </div>
          <v-divider v-if="constructionPrix.bonificationQualiteTotaleEnEuroParTonne" />
          <div v-if="constructionPrix.bonificationQualiteTotaleEnEuroParTonne">
            <div
              v-for="(bonificationQual, indexBon) in constructionPrix.bonificationsQualite"
              :key="indexBon"
              class="d-flex flex-column my-2"
            >
              <div class="d-flex justify-space-around align-center">
                <span class="texte secondary--text numeroBon">
                  N°{{ bonificationQual.numeroBon }}
                </span>
                <span class="texte texte-gris-fonce">
                  {{ bonificationQual.quantiteEnKg / 1000 | roundNumber(2) }} t
                </span>
                <v-chip
                  :color="getChipColor(bonificationQual.bonificationEnEuroParTonne)"
                  class="chip"
                  close-icon="mdi-delete"
                  label
                >
                  <span
                    :class="getChipColor(bonificationQual.bonificationEnEuroParTonne) === 'white' ? 'secondary--text' : '--text-white'"
                    class="texte"
                  >
                    {{ formatValeurAddition(bonificationQual.bonificationEnEuroParTonne, 1, '€/t') }}
                  </span>
                </v-chip>
                <v-btn
                  color="primary"
                  icon
                  @click="onApportsClick(bonificationQual.numeroBon)"
                >
                  <v-icon color="secondary">
                    mdi-chevron-right
                  </v-icon>
                </v-btn>
              </div>
              <v-divider
                v-if="indexBon !== constructionPrix.bonificationsQualite.length - 1"
                class="my-2"
              />
            </div>
          </div>
          <v-divider v-if="constructionPrix.bonificationQualiteTotaleEnEuroParTonne" />
          <div
            v-if="constructionPrix.primeEngagementEnEuroParTonne"
            class="d-flex pt-2 justify-space-between"
          >
            <span class="intro texte-gris-fonce py-3">
              Prime d'engagement
            </span>
            <span class="titre-h4 py-2 align-end secondary--text">
              {{ formatValeurAddition(constructionPrix.primeEngagementEnEuroParTonne, 2, '€/t') }}
            </span>
          </div>
          <v-divider v-if="constructionPrix.primeEngagementEnEuroParTonne" />
          <div
            v-if="constructionPrix.primeDiversEnEuroParTonne"
            class="d-flex pt-2 justify-space-between"
          >
            <span class="intro texte-gris-fonce py-3">
              Prime divers
            </span>
            <span class="titre-h4 py-2 align-end secondary--text">
              {{ formatValeurAddition(constructionPrix.primeDiversEnEuroParTonne, 2, '€/t') }}
            </span>
          </div>
          <v-divider v-if="constructionPrix.primeDiversEnEuroParTonne" />
          <div
            v-if="constructionPrix.bonificationDurabiliteEnEuroParTonne"
            class="d-flex pt-2 justify-space-between"
          >
            <span class="intro texte-gris-fonce py-3">
              Durabilité
            </span>
            <span class="titre-h4 py-2 align-end secondary--text">
              {{ formatValeurAddition(constructionPrix.bonificationDurabiliteEnEuroParTonne, 2, '€/t') }}
            </span>
          </div>
          <v-divider v-if="constructionPrix.bonificationDurabiliteEnEuroParTonne" />
          <div
            v-if="constructionPrix.interetDepassementEnEuroParTonne"
            class="d-flex pt-2 justify-space-between"
          >
            <span class="intro texte-gris-fonce py-3">
              Intérêts de dépassement
            </span>
            <span class="titre-h4 py-2 align-end secondary--text">
              {{ formatValeurAddition(constructionPrix.interetDepassementEnEuroParTonne, 2, '€/t') }}
            </span>
          </div>
          <v-divider v-if="constructionPrix.interetDepassementEnEuroParTonne" />
          <div
            v-if="constructionPrix.fraisTransportEnEuroParTonne"
            class="d-flex pt-2 justify-space-between"
          >
            <span class="intro texte-gris-fonce py-3">
              Frais de transport
            </span>
            <span class="titre-h4 py-2 align-end secondary--text">
              {{ formatValeurAddition(constructionPrix.fraisTransportEnEuroParTonne, 2, '€/t') }}
            </span>
          </div>
          <v-divider v-if="constructionPrix.fraisTransportEnEuroParTonne" />
          <div
            v-if="constructionPrix.fraisStockageEnEuroParTonne"
            class="d-flex pt-2 justify-space-between"
          >
            <span class="intro texte-gris-fonce py-3">
              Frais de stockage
            </span>
            <span class="titre-h4 py-2 align-end secondary--text">
              {{ formatValeurAddition(constructionPrix.fraisStockageEnEuroParTonne, 2, '€/t') }}
            </span>
          </div>
          <v-divider v-if="constructionPrix.fraisStockageEnEuroParTonne" />
          <div
            v-if="constructionPrix.fraisPriseEnChargeEnEuroParTonne"
            class="d-flex pt-2 justify-space-between"
          >
            <span class="intro texte-gris-fonce py-3">
              Frais de prise en charge
            </span>
            <span class="titre-h4 py-2 align-end secondary--text">
              {{ formatValeurAddition(constructionPrix.fraisPriseEnChargeEnEuroParTonne, 2, '€/t') }}
            </span>
          </div>
          <v-divider v-if="constructionPrix.fraisPriseEnChargeEnEuroParTonne" />
          <div
            v-if="constructionPrix.fraisCapitalSocialEnEuroParTonne"
            class="d-flex pt-2 justify-space-between"
          >
            <span class="intro texte-gris-fonce py-3">
              Capital social
            </span>
            <span class="titre-h4 py-2 align-end secondary--text">
              {{ formatValeurAddition(constructionPrix.fraisCapitalSocialEnEuroParTonne, 2, '€/t') }}
            </span>
          </div>
          <v-divider
            class="divider-equal"
          />
          <div class="d-flex pt-2 justify-space-between">
            <span class="intro texte-gris-fonce secondary--text py-3">
              Prix payé {{ isPrixProvisoire ? 'provisoire' : '' }}
            </span>
            <span class="titre-h4 py-2 align-end secondary--text">
              {{ constructionPrix.prixPayeEnEuroParTonne | roundNumber(2) }} €/t
            </span>
          </div>
        </div>
      </v-expansion-panel-content>
    </v-expansion-panel>
  </v-expansion-panels>
</template>

<script>
import {round} from 'lodash'
import {isBefore, parse} from 'date-fns'

export default {
  name: 'DetailsContratConstructionPrix',
  components: {},
  props: {
    detailsContrat: {
      type: Object,
      required: true
    },
  },

  computed: {
    constructionPrix () {
      return this.detailsContrat.detailsConstructionPrix
    },

    isPrixEnCoursConstruction () {
      const list = ['Prix campagne', 'Contrat filière', 'Prix par période']
      return list.includes(this.detailsContrat.type.categorieContrat)
    },

    isPrixProvisoire () {
      const anneeRecolte = Number(this.detailsContrat.anneeRecolte) + 1
      const formatDateLimite = anneeRecolte + '-07-01'
      const dateLimite = parse(formatDateLimite, 'yyyy-MM-dd', new Date())
      return this.isPrixEnCoursConstruction && isBefore(new Date(), dateLimite)
    },
  },

  methods: {
    formatValeurAddition (valeur, precision, unite) {
      let formatted = ''

      if (valeur >= 0) {
        formatted += '+ '
      }
      formatted += round(valeur, precision)
      formatted += ' ' + unite
      return formatted
    },

    getChipColor (valeur) {
      if (valeur > 0) {
        return 'secondary'
      } else if (valeur < 0) {
        return '#EC6608'
      } else {
        return 'white'
      }
    },

    onApportsClick (numApport) {
      this.$router.push({ name: 'main.mes-recoltes', params:{
          anneeRecolte: this.detailsContrat.anneeRecolte,
          codeGraineRs3: this.detailsContrat.codeIdaRs3,
          numeroContrat: this.detailsContrat.numeroContrat,
          numeroApport: numApport
        }})
    }
  }
}
</script>

<style lang="scss" scoped>
.divider-equal {
  padding-top: 1px;
  border-color: #006E33;
}

.numeroBon {
  width: 90px;
}

.chip {
  width: 78px;
}
</style>
